<!-- eslint-disable vue/no-v-html -->
<template>
  <Form
    v-if="form"
    v-bind="form"
  />
</template>

<script lang="ts" setup>
import Form from '~/components/Atoms/Form/Form.vue';
import type { PortableTextForm } from '~/sanity/types';
defineProps<PortableTextForm>();
</script>
